import { usePrequelContext } from 'modules/dataSync/contexts';
import { Modal, ModalBody, ModalFooter, ModalHeader, MODAL_SIZES } from 'ui/modal';
import { PrimaryButton } from 'ui/button';
import { ExpandModes } from 'utils/contexts/expansion';
import { DESTINATIONS_LIST } from '../../constants/prequel';
import { DestinationCard } from '../DestinationCard';
import { DestinationCardsWrapper } from './CreateDestinationModal.styles';
import { useDataSyncTranslations } from 'modules/dataSync/hooks/useDataSyncTranslations';

export const CreateDestinationModal = () => {
  const { toggleIsModalShown, modalExpandMode, setSelectedDestination, navigateToCreate } =
    usePrequelContext();

  const onModalClose = () => {
    setSelectedDestination(DESTINATIONS_LIST.bigquery.id);
    toggleIsModalShown();
  };

  const { t } = useDataSyncTranslations();
  const isModalOpen = modalExpandMode === ExpandModes.expand;

  const handleContinue = () => {
    // Navigate to create view with the selected destination
    navigateToCreate();
  };

  return (
    <Modal
      id="create-destination-modal"
      isModalOpen={isModalOpen}
      onClose={onModalClose}
      size={MODAL_SIZES.LARGE}
    >
      <ModalHeader>
        <span>{t('modal.createDestination.title')}</span>
      </ModalHeader>
      <ModalBody>
        <DestinationCardsWrapper>
          {Object.values(DESTINATIONS_LIST).map((destination) => (
            <DestinationCard
              key={destination.id}
              onSelect={() => setSelectedDestination(destination.id)}
              destination={destination}
            />
          ))}
        </DestinationCardsWrapper>
      </ModalBody>
      <ModalFooter>
        <PrimaryButton onClick={handleContinue}>
          {t('modal.createDestination.continueButtonLabel')}
        </PrimaryButton>
      </ModalFooter>
    </Modal>
  );
};
